import React from 'react';
import { motion } from 'framer-motion';
import { Mic, Sparkles } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 md:px-12 py-24 overflow-hidden" data-testid="hero-section">
      {/* Background glow */}
      <div className="hero-glow breathe" />

      {/* Grid pattern */}
      <div className="absolute inset-0 grid-pattern opacity-30" />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0A0A0A] border border-[#1F1F1F] mb-8"
        >
          <Sparkles className="w-4 h-4 text-[#8B5CF6]" />
          <span className="text-xs font-mono uppercase tracking-[0.2em] text-[#888888]">Early Access</span>
        </motion.div>

        {/* Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 40, filter: 'blur(10px)' }}
          animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="text-5xl md:text-7xl lg:text-8xl font-medium tracking-tighter text-[#EDEDED] mb-6"
          data-testid="hero-headline"
        >
          Speak your chaos.
          <br />
          <span className="text-glow text-[#8B5CF6]">See your clarity.</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          initial={{ opacity: 0, y: 40, filter: 'blur(10px)' }}
          animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="text-base md:text-lg leading-relaxed text-[#888888] max-w-2xl mx-auto mb-12"
          data-testid="hero-subheadline"
        >
          Your mind wasn't built to remember everything. Neuron was.<br />
          Voice it. Type it. Paste it. It's safe now.
        </motion.p>



      </div>

      {/* Creative Scroll Indicator - Data Drop */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.8 }}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center justify-center gap-4 z-20"
      >
        <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#555]">
          Scroll to sync
        </span>
        <div className="relative w-[1px] h-16 bg-[#1f1f1f] overflow-hidden rounded-full">
          <motion.div
            className="absolute top-0 left-0 w-full h-[40%]"
            style={{
              background: 'linear-gradient(to bottom, transparent, #8B5CF6, #FFFFFF)'
            }}
            animate={{ y: ['-100%', '300%'] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: 'circIn', repeatDelay: 0.2 }}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
